import { useMutation, useQuery } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import OdooPOPreview from "components/shared/OdooPOPreview";
import { v4 } from "uuid";
import { FETCH_PLAN_SUMMARY } from "../graphql";
import { SYNC_PLAN_TO_ODOO } from "../syncPlanToOdooViews/graphql";

const CreateIncOdooPoView = ({ planId, hide }) => {
  const { loading, error, data } = useQuery(FETCH_PLAN_SUMMARY, {
    variables: { id: planId },
    fetchPolicy: "network-only",
  });
  const [create, createRes] = useMutation(SYNC_PLAN_TO_ODOO, {
    variables: { planId, instance: "INC", orderType: "PO", createNew: true },
    onCompleted() {
      Alert("success", "PO Created Successfully");
      hide();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_PLAN_FOR_INC_ODOO"],
    awaitRefetchQueries: true,
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const orderLines = data.productionPlan.finalLines.reduce((res, i) => {
    const found = res.find(
      (x) =>
        x.productId === i.product.id &&
        x.salesPrice === i.salesPrice &&
        x.discountPercentage === i.discountPercentage,
    );
    if (found)
      return res.map((x) =>
        x.id === found.id
          ? {
              ...x,
              qty: x.qty + i.finalQty,
              totalPrice: x.totalPrice + i.totalPrice,
            }
          : x,
      );
    return [
      ...res,
      {
        id: v4(),
        productId: i.product.id,
        name: `[${i.product.number}] ${i.product.name}`,
        qty: i.finalQty,
        salesPrice: i.salesPrice,
        discountPercentage: i.discountPercentage,
        totalPrice: i.totalPrice,
      },
    ];
  }, []);

  return (
    <div className=" space-y-6 text-sm">
      <div className="card">
        <OdooPOPreview
          orderLines={orderLines}
          orderTotal={data.productionPlan.finalTotalPrice}
        />
      </div>

      <div>
        <Button primary onClick={create} loading={createRes.loading}>
          Create Purchase Order
        </Button>
      </div>
    </div>
  );
};

export default CreateIncOdooPoView;
